module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-frame"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('strong', [_vm._v(_vm._s(_vm.content.profile.firstName))]), _vm._v(" " + _vm._s(_vm.content.profile.lastName))]), _vm._v(" "), _c('div', {
    staticClass: "menu desk"
  }, [_c('div', {
    staticClass: "menu-items"
  }, [_vm._l((_vm.content.sections), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "menu-item",
      attrs: {
        "href": '#' + item.id
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])])
  }), _vm._v(" "), (_vm.withDownload) ? _c('div', {
    staticClass: "menu-item download",
    on: {
      "click": _vm.openPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "false"
    }
  })]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "menu mob"
  }, [_c('div', {
    staticClass: "menu-picto",
    class: {
      open: _vm.menu
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-2x",
    attrs: {
      "aria-hidden": "false"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    staticClass: "menu-items"
  }, [_vm._l((_vm.content.sections), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "menu-item",
      attrs: {
        "href": '#' + item.id
      },
      on: {
        "click": _vm.showMenu
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])])
  }), _vm._v(" "), (_vm.withDownload) ? _c('div', {
    staticClass: "menu-item download",
    on: {
      "click": _vm.openPdf
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    staticStyle: {
      "padding-right": "0.5rem"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Télécharger")])]) : _vm._e()], 2)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e61b646"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 46
// module chunks = 0